import { checkoutApi } from "./checkout.api";

export const { useSaveCheckoutLogMutation } = checkoutApi;
